import React, { useRef, useState } from "react";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";
import { trackCTAClick } from "../utils/analytics";

const MagneticButton = ({ children, className = "", href, onClick, ...props }) => {
  const ref = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  
  const springConfig = { damping: 15, stiffness: 150 };
  const xSpring = useSpring(x, springConfig);
  const ySpring = useSpring(y, springConfig);
  
  const handleMouseMove = (e) => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    const distanceX = e.clientX - centerX;
    const distanceY = e.clientY - centerY;
    const distance = Math.sqrt(distanceX ** 2 + distanceY ** 2);
    
    if (distance < 100) {
      x.set(distanceX * 0.3);
      y.set(distanceY * 0.3);
    } else {
      x.set(0);
      y.set(0);
    }
  };
  
  const handleMouseLeave = () => {
    x.set(0);
    y.set(0);
    setIsHovered(false);
  };
  
  const handleMouseEnter = () => {
    setIsHovered(true);
  };
  
  const Component = href ? motion.a : motion.button;
  
  const handleClick = (e) => {
    // Track CTA clicks automatically
    if (href) {
      const buttonText = typeof children === 'string' ? children : 'CTA Button';
      const location = className.includes('hero') ? 'hero' : 
                      className.includes('footer') ? 'footer' : 
                      className.includes('cta') ? 'cta_section' : 'other';
      trackCTAClick(buttonText, location, href);
    }
    
    // Call custom onClick if provided
    if (onClick) {
      onClick(e);
    }
  };
  
  return (
    <Component
      ref={ref}
      href={href}
      onClick={handleClick}
      className={className}
      style={{
        x: xSpring,
        y: ySpring,
        position: "relative",
        overflow: "hidden"
      }}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      onMouseEnter={handleMouseEnter}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      transition={{ type: "spring", stiffness: 300, damping: 20 }}
      {...props}
    >
      {children}
      {isHovered && (
        <motion.span
          className="ripple-effect"
          initial={{ scale: 0, opacity: 0.6 }}
          animate={{ scale: 4, opacity: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            width: "20px",
            height: "20px",
            borderRadius: "50%",
            background: "rgba(255, 255, 255, 0.6)",
            pointerEvents: "none",
            transform: "translate(-50%, -50%)"
          }}
        />
      )}
    </Component>
  );
};

export default MagneticButton;

